// Anything exported from this file is importable by other in-browser modules.
import variables from './scss/_variables-export.module.scss';

export { default as colors } from './scss/_colors-export.module.scss';

export { default as Button, ButtonMode, ButtonSize } from './components/Button';
export { default as ButtonGroup } from './components/ButtonGroup';
export { default as Checkbox, type CheckboxProps } from './components/Checkbox';
export { default as Dropdown } from './components/Dropdown';
export { default as Filter } from './components/Filter';
export { default as FilterBox } from './components/FilterBox';
export { default as DateRange, getDateRange } from './components/DateRange';
export { default as Icon, ICONS } from './components/Icon';
export {
  Modal,
  ModalProvider as GlobalModalProvider,
  useModalContext as useGlobalModalContext,
  ModalWidth,
} from './components/Modal';
export { default as Alert } from './components/Alert';
export { default as PrintView } from './components/PrintView';
export { default as Tabs, type TabData } from './components/Tabs';
export { default as Toaster, ToasterMode } from './components/Toaster';
export { default as Tooltip, TooltipPosition } from './components/Tooltip';
export { default as TreeSelect, type TreeNodeModel } from './components/TreeSelect';
export { default as Widget, type WidgetProps, type SortableWidgetProps } from './components/Widget';
export { default as Loader } from './components/Loader';
export { default as DataLoadError } from './components/DataLoadError';
export { default as Divider } from './components/Divider';
export { default as Table } from './components/Table';
export { default as Popup } from './components/Popup';
export {
  default as DataView,
  type KeyTypes,
  type DataViewConfig,
  type TableViewConfig,
  type ExpandedViewConfig,
  type DataItemFormatter,
  type TableColumns,
} from './components/DataView';
export { default as CheckboxList } from './components/CheckboxList';
export { default as ContentTypeTag } from './components/ContentTypeTag';
export { default as CoverageIndicator } from './components/CoverageIndicator';
export { default as Pagination } from './components/Pagination';
export { default as Chip } from './components/Chip';
export {
  PieChart,
  type PieChartOption,
  BarChart,
  type BarChartOption,
  LineChart,
  type LineChartOption,
  type ChartHandle,
} from './components/Charts';
export { CircleBar } from './components/ScoreCharts';
export {
  default as AGTable,
  type AGTableProps,
  agTableGetColumns,
  agTableValueComparator,
  AG_TABLE_HEADER_HEIGHT,
  AG_TABLE_ROW_HEIGHT,
  EXCEL_STYLES,
} from './components/AGTable';
export { default as ActionButton } from './components/ActionButton';

export { default as useCopyPasteGuard } from './hooks/useCopyPasteGuard';
export { default as CustomDatePicker } from './components/DateRange/DatePicker';

export const headerHeight = parseFloat(variables.header_height);
export const subheaderHeight = parseFloat(variables.subheader_height);
export const rightSectionWidth = parseFloat(variables.right_section_width);
